import React, { useEffect, useState, useRef } from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'La ART me quería dar el alta y yo no estaba recuperado. Con el Tomo 2 armé la carta de impugnación en una hora. Me prorrogaron la baja sin necesitar abogado.',
  author: 'Marcelo D.',
  location: 'Buenos Aires — Trabajador metalúrgico'
}, {
  quote: 'Mi propietario me quería cobrar un aumento en dólares. Mandé la carta del Tomo 4 y al otro día me llamó para arreglar. Nunca supe que tenía esos derechos.',
  author: 'Florencia R.',
  location: 'Córdoba — Inquilina'
}, {
  quote: 'El banco me cobraba mantenimiento de cuenta sueldo desde hace dos años. Con el Tomo 6 hice el reclamo ante el BCRA y me devolvieron todo lo que me habían sacado.',
  author: 'Rodrigo M.',
  location: 'Rosario — Empleado en relación de dependencia'
}];
export function Testimonials() {
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (!scrollRef.current) return;
      const scrollLeft = scrollRef.current.scrollLeft;
      const cardWidth = scrollRef.current.offsetWidth;
      const index = Math.round(scrollLeft / cardWidth);
      setActiveIndex(index);
    };
    const ref = scrollRef.current;
    if (ref) {
      ref.addEventListener('scroll', handleScroll);
      return () => ref.removeEventListener('scroll', handleScroll);
    }
  }, []);
  return <section className="py-12 md:py-[70px] px-5 bg-white" data-id="element-252">
      <div className="max-w-[860px] mx-auto" data-id="element-253">
        <div className="text-[11px] font-extrabold tracking-[0.14em] uppercase text-blue mb-2" data-id="element-254">
          Lo que dice la gente
        </div>
        <h2 className="font-display text-[clamp(28px,6vw,52px)] text-navy mb-2 leading-tight" data-id="element-255">
          Resultados reales de personas reales
        </h2>
        <p className="text-[15px] md:text-[16px] text-text-muted max-w-[560px] mb-6 md:mb-12" data-id="element-256">
          Ciudadanos que dejaron de perder reclamos válidos por no saber cómo
          presentarlos.
        </p>

        {/* Mobile: Swipeable Carousel */}
        <div className="md:hidden" data-id="element-257">
          <div ref={scrollRef} className="flex overflow-x-auto snap-x snap-mandatory gap-3 pb-4 scrollbar-hide" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-258">
            {testimonials.map((t, i) => <div key={i} className="flex-shrink-0 w-[85%] snap-center" data-id="element-259">
                <div className="bg-off-white border border-border rounded-xl p-5 relative h-full" data-id="element-260">
                  <div className="absolute -top-2.5 left-5 font-serif text-[80px] text-gold leading-none opacity-30" data-id="element-261">
                    "
                  </div>
                  <div className="flex text-gold mb-3 relative z-10" data-id="element-262">
                    {[...Array(5)].map((_, j) => <Star key={j} size={14} fill="currentColor" data-id="element-263" />)}
                  </div>
                  <p className="text-[14px] leading-relaxed mb-4 italic text-text-main relative z-10" data-id="element-264">
                    {t.quote}
                  </p>
                  <div className="relative z-10" data-id="element-265">
                    <strong className="block font-bold text-[13px]" data-id="element-266">
                      {t.author}
                    </strong>
                    <span className="text-[11px] text-text-muted" data-id="element-267">
                      {t.location}
                    </span>
                  </div>
                </div>
              </div>)}
          </div>

          {/* Dot Indicators */}
          <div className="flex justify-center gap-2 mt-4" data-id="element-268">
            {testimonials.map((_, i) => <button key={i} onClick={() => {
            if (scrollRef.current) {
              scrollRef.current.scrollTo({
                left: i * scrollRef.current.offsetWidth,
                behavior: 'smooth'
              });
            }
          }} className={`w-2 h-2 rounded-full transition-all ${i === activeIndex ? 'bg-gold w-6' : 'bg-border'}`} aria-label={`Go to testimonial ${i + 1}`} data-id="element-269" />)}
          </div>
        </div>

        {/* Desktop: 3-col Grid */}
        <div className="hidden md:grid grid-cols-3 gap-5" data-id="element-270">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-off-white border border-border rounded-xl p-6 relative" data-id="element-271">
              <div className="absolute -top-2.5 left-5 font-serif text-[80px] text-gold leading-none opacity-30" data-id="element-272">
                "
              </div>
              <div className="flex text-gold mb-3 relative z-10" data-id="element-273">
                {[...Array(5)].map((_, j) => <Star key={j} size={14} fill="currentColor" data-id="element-274" />)}
              </div>
              <p className="text-[15px] leading-relaxed mb-4 italic text-text-main relative z-10" data-id="element-275">
                {t.quote}
              </p>
              <div className="relative z-10" data-id="element-276">
                <strong className="block font-bold text-[14px]" data-id="element-277">
                  {t.author}
                </strong>
                <span className="text-[12px] text-text-muted" data-id="element-278">
                  {t.location}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}